module.exports = __webpack_public_path__ + "img/26-ram-2500-3500.370710b7.jpg";